module.exports = __webpack_public_path__ + "img/boss-img.c24a3e15.png";